import React from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { push, replace } from 'connected-react-router';

import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Toolbar from '@material-ui/core/Toolbar';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
import { Paper } from '@material-ui/core';

import Avatar from '../../components/Avatar';

import Page from '../../components/Page';
import Pagination from '../../components/Pagination';
import styled from './MessagesStyles';

import { actions } from '../../services/messages';

class Messages extends React.Component {
  getParams() {
    const defaultParams = {
      page: 0,
      type: 'all'
    };

    const parsed = queryString.parse(this.props.search);
    const params = Object.assign(defaultParams, parsed);
    params.page = parseInt(params.page);

    return params;
  }

  updateParams(newParams, usePush = false) {
    const params = this.getParams();
    const search = queryString.stringify(Object.assign(params, newParams));
    if (usePush) {
      this.props.actions.push(this.props.pathname + '?' + search);
    } else {
      this.props.actions.replace(this.props.pathname + '?' + search);
    }
  }

  componentDidMount() {
    this.props.actions.load(this.getParams());
  }

  setFilter = event => {
    this.updateParams({
      [event.target.name]: event.target.value
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      const { actions } = this.props;
      actions.load(this.getParams());
    }
  }

  nextPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page + 1 }, true);
  };

  prevPage = () => {
    const { page } = this.getParams();
    this.updateParams({ page: page - 1 }, true);
  };

  renderRow(message) {
    const { classes } = this.props;

    return (
      <TableRow key={message._id}>
        <TableCell padding="dense">
          <ButtonBase
            component={Link}
            to={`/users/${message.fromUser._id}`}
            className={classes.user}
          >
            <Avatar user={message.fromUser} size={80} />
            {message.fromUser.firstName}
          </ButtonBase>
        </TableCell>

        <TableCell padding="dense">
          <ButtonBase
            component={Link}
            to={`/users/${message.toUser._id}`}
            className={classes.user}
          >
            <Avatar user={message.toUser} size={80} />
            {message.toUser.firstName}
          </ButtonBase>
        </TableCell>

        <TableCell padding="dense">
          <Typography className={classes.timeAgo}>
            {moment(message.createTime).fromNow()}
          </Typography>
        </TableCell>

        <TableCell padding="dense">
          {message.type === 'text' ? (
            <Typography>{message.message}</Typography>
          ) : (
            <img
              className={classes.messagePhoto}
              src={`${process.env.REACT_APP_CDN_HOST}/messages/${
                message.files[0].path
              }`}
              alt={message.fromUser.firstName}
            />
          )}
        </TableCell>
        <TableCell padding="dense">
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={'/matches/' + message.matchId}
          >
            View Match
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const { classes, loading, total, perPage, messages } = this.props;
    const params = this.getParams();
    return (
      <Page title="Messages" loading={loading}>
        <Paper>
          <Toolbar className={classes.toolbar}>
            <Typography>Messages - {total}</Typography>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="type">Type</InputLabel>
              <Select
                value={params.type}
                onChange={this.setFilter}
                inputProps={{
                  name: 'type',
                  id: 'type'
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="photo">Photo</MenuItem>
              </Select>
            </FormControl>
          </Toolbar>
        </Paper>

        <div className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>From</TableCell>
                <TableCell>To</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Match</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{messages.map(item => this.renderRow(item))}</TableBody>
          </Table>
        </div>

        <Pagination
          total={total}
          perPage={perPage}
          page={params.page}
          onNext={this.nextPage}
          onPrev={this.prevPage}
        />
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.messages.loading,
    messages: state.messages.messages,
    total: state.messages.total,
    perPage: state.messages.perPage,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: filters => dispatch(actions.load(filters)),
    setFilters: payload => dispatch(actions.setFilters(payload)),
    push: payload => dispatch(push(payload)),
    replace: payload => dispatch(replace(payload))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(Messages))
);
